<template>
	<lcsj-dialog v-model="showDialog" :title="title" width="70%" @close="closeDialog" cancel-text="关闭">
		<div class="history-dialog-content">
			<el-descriptions class="margin-top" :column="3" border size="small">
				<el-descriptions-item label="会员名称">{{ currentRow.customerInfo ? currentRow.customerInfo.name : "" }}</el-descriptions-item>
				<el-descriptions-item label="当前卡号">{{ currentRow.vipNo }}</el-descriptions-item>
				<el-descriptions-item label="会员电话">{{ currentRow.customerInfo ? currentRow.customerInfo.phone : "" }}</el-descriptions-item>
			</el-descriptions>
			<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="listData" v-loading="loading" border stripe size="small" style="margin-top: 12px" empty-text="暂无卡号修改记录">
				<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
				<el-table-column prop="createTime" label="修改时间" align="center" width="160"></el-table-column>
				<el-table-column label="原卡号" align="center" min-width="120">
					<template #default="scope">
						<span style="color: var(--app-text-muted)">{{ scope.row.oldVipNo }}</span>
					</template>
				</el-table-column>
				<el-table-column label="新卡号" align="center" min-width="120">
					<template #default="scope">
						<span style="color: var(--app-primary-text); font-weight: 600">{{ scope.row.newVipNo }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="修改原因" align="center" min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="creator" label="操作人" align="center" width="120"></el-table-column>
			</el-table>
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</div>
		
	</lcsj-dialog>
</template>
<script>
import { GetVipCardChangeHistoryPageList } from "@/api/vipApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			loading: false,
			title: "会员卡号修改记录",
			currentRow: {
				keyId: "",
				vipNo: "",
				customerInfo: {}
			},
			pageShow: true,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			}
		};
	},
	components: {},
	created() {},
	methods: {
		// 显示
		getHistoryDialog(row) {
			this.currentRow = row;
			this.title = "会员卡号修改记录" + (row.customerInfo && row.customerInfo.name ? " - " + row.customerInfo.name : "");
			this.pageparm.pageIndex = 1;
			this.showDialog = true;
			this.$nextTick(() => {
				this.getListData();
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				pageIndex: this.pageparm.pageIndex,
				pageSize: this.pageparm.pageSize,
				vipKeyId: this.currentRow.keyId
			};
			GetVipCardChangeHistoryPageList(params)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.listData = [];
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.pageparm.pageIndex = 1;
			} else {
				this.pageparm.pageIndex = parm.currentPage;
			}
			this.pageparm.pageSize = parm.pageSize;
			this.getListData();
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
			this.listData = [];
		}
	}
};
</script>
<style scoped lang="scss">
.history-dialog-content {
	width: 100%;
	padding: 0 4px;
}

.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}
</style>
